import { useState } from 'react'

// material-ui
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import ButtonBase from '@mui/material/ButtonBase'

// project imports

// assets
import { IconLockAccess, IconLogout } from '@tabler/icons-react'
import { logout } from '../../../../../app/features/auth/authSlice'
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks'
import { authStore, customTheme } from '../../../../../app/selectedStore'
import ChangePassword from '../../../../dialog/ChangePassword'
import NotificationSection from '../NotificationSection'

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
  const theme = useTheme()
  const customization = useAppSelector(customTheme)
  const auth = useAppSelector(authStore).user
  const dispatch = useAppDispatch()

  // const [sdm, setSdm] = useState(true)
  // const [notification, setNotification] = useState(false)
  const [openModalChangePass, setOpenModalChangePass] = useState(false)

  const handleLogout = async () => {
    dispatch(logout())
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: customization.opened ? 'row' : 'column',
          alignItems: 'center',
          justifyContent: customization.opened ? 'flex-start' : 'center',
          gap: customization.opened ? 1.5 : 1,
          p: customization.opened ? 1 : 0,
          borderRadius: '12px',
          mb: customization.opened ? 1 : 0
        }}
      >
        {!customization.opened && <NotificationSection />}
        <Avatar
          src={auth?.staff?.avatar}
          sx={{
            width: 34,
            height: 34,
            fontSize: '1.2rem',
            border: `2px solid ${theme.palette.primary.main}`
          }}
          color='inherit'
        />
        {customization.opened && (
          <>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant='subtitle2'
                sx={{ color: '#fff', fontWeight: 600, fontSize: '0.8rem', lineHeight: 1.2, display: 'block' }}
                noWrap
              >
                {auth?.staff?.name}
              </Typography>
              <Typography variant='caption' sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem' }} noWrap>
                {auth?.username}
              </Typography>
            </Box>
            <NotificationSection />
          </>
        )}
      </Box>

      {customization.opened ? (
        <Stack spacing={0.5}>
          <ListItemButton
            sx={{
              borderRadius: `${customization.borderRadius}px`,
              color: 'rgba(255,255,255,0.7)',
              '&:hover': { background: 'rgba(255,255,255,0.1)', color: '#fff' }
            }}
            onClick={() => setOpenModalChangePass(true)}
          >
            <ListItemIcon sx={{ minWidth: 32, color: 'inherit' }}>
              <IconLockAccess stroke={1.5} size='1.1rem' />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant='body2' sx={{ fontSize: '0.75rem' }}>
                  Đổi mật khẩu
                </Typography>
              }
            />
          </ListItemButton>
          <ListItemButton
            sx={{
              borderRadius: `${customization.borderRadius}px`,
              color: 'rgba(255,255,255,0.7)',
              '&:hover': { background: 'rgba(255,255,255,0.1)', color: '#fff' }
            }}
            onClick={handleLogout}
          >
            <ListItemIcon sx={{ minWidth: 32, color: 'inherit' }}>
              <IconLogout stroke={1.5} size='1.1rem' />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant='body2' sx={{ fontSize: '0.75rem' }}>
                  Đăng xuất
                </Typography>
              }
            />
          </ListItemButton>
        </Stack>
      ) : (
        <Stack alignItems='center' spacing={1} sx={{ mt: 1 }}>
          <ButtonBase
            onClick={() => setOpenModalChangePass(true)}
            sx={{ color: 'rgba(255,255,255,0.7)', '&:hover': { color: '#fff' } }}
          >
            <IconLockAccess stroke={1.5} size='1.1rem' />
          </ButtonBase>
          <ButtonBase onClick={handleLogout} sx={{ color: 'rgba(255,255,255,0.7)', '&:hover': { color: '#fff' } }}>
            <IconLogout stroke={1.5} size='1.1rem' />
          </ButtonBase>
        </Stack>
      )}
      <ChangePassword handleClose={() => setOpenModalChangePass(false)} open={openModalChangePass} />
    </Box>
  )
}

export default ProfileSection
